<template>
    <div class="flex flex-col gap-4">
        <BookkeepableDetails v-if="actionable" :actionable="actionable" />

        <div class="flex gap-2 mt-4">
            <UButton
                color="primary"
                icon="i-ph-check"
                :loading="approving"
                @click="approve"
            >
                Godkjenn
            </UButton>
            <UButton
                color="error"
                variant="outline"
                icon="i-ph-x"
                :loading="rejecting"
                @click="reject"
            >
                Avvis
            </UButton>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { Bookkeepable } from '@/assignments/BookkeepingActionable/BookkeepingActionable.type'
import BookkeepableDetails from '@/assignments/BookkeepingActionable/BookkeepableDetails.vue'
import { completeAssignment, rejectAssignment } from '@/assignments/assignment.service'

const props = defineProps({
    assignmentUuid: {
        type: String,
        required: true,
    },
    actionable: {
        type: Object as () => Bookkeepable,
        default: null,
    },
})

const approving = ref(false)
const rejecting = ref(false)

const approve = async () => {
    approving.value = true
    try {
        await completeAssignment(props.assignmentUuid)
    } finally {
        approving.value = false
    }
}

const reject = async () => {
    rejecting.value = true
    try {
        await rejectAssignment(props.assignmentUuid)
    } finally {
        rejecting.value = false
    }
}
</script>
